import { useMsal } from '@azure/msal-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { logger } from '@/services/logger';

/**
 * Component displayed when a user lacks the required permissions to access the application
 */
export function InsufficientPermissions() {
  const { instance } = useMsal();

  /**
   * Handle user sign-out
   */
  const handleSignOut = () => {
    instance.logoutPopup()
      .then(() => {
        logger.trackEvent('UserSession.SignedOut', { reason: 'InsufficientPermissions' });
      })
      .catch((e) => {
        logger.error(e, { context: 'SignOut' });
      });
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Access Denied</CardTitle>
          <CardDescription>
            You do not have the required permissions to access this application.
            Please contact your administrator if you believe this is an error.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button onClick={handleSignOut} variant="outline" className="w-full">
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
